<template>
  <div>
    <div class="wrapper">
      <input type="radio" name="Estamento" id="Estamento-1" @click="selectedEstamento('Administrativos')"/>
      <input type="radio" name="Estamento" id="Estamento-2" @click="selectedEstamento('Técnicos')"/>
      <input type="radio" name="Estamento" id="Estamento-3" @click="selectedEstamento('Profesionales')"/>
      <input type="radio" name="Estamento" id="Estamento-4" @click="selectedEstamento('Auxiliares')"/>
      <input type="radio" name="Estamento" id="Estamento-5" @click="selectedEstamento('Administrativos,Técnicos,Profesionales,Auxiliares')"/>

      <label for="Estamento-1" class="Estamento Estamento-1">
        <div class="dot"></div>
        <span>Administrativos</span>
      </label>
      <label for="Estamento-2" class="Estamento Estamento-2">
        <div class="dot"></div>
        <span>Técnicos</span>
      </label>
      <label for="Estamento-3" class="Estamento Estamento-3">
        <div class="dot"></div>
        <span>Profesionales</span>
      </label>
      <label for="Estamento-4" class="Estamento Estamento-4">
        <div class="dot"></div>
        <span>Auxiliares</span>
      </label>
      <label for="Estamento-5" class="Estamento Estamento-5">
        <div class="dot"></div>
        <span>Todos</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    selectedEstamento: function(selected) {
      this.$store.commit("setRHEstamento", selected)
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
}
html,
body {
  display: grid;
  height: 100%;
  place-items: center;
  background: #0069d9;
  font-family: "Fira Sans", sans-serif;
}
.wrapper {
  background: #fff;
  height: 100px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
}
.wrapper .Estamento {
  background: #e0e0e0;
  height: 50px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  margin-right: 15px;
}

.wrapper .Estamento .dot::before {
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"] {
  display: none;
}
#Estamento-1:checked:checked ~ .Estamento-1,
#Estamento-2:checked:checked ~ .Estamento-2,
#Estamento-3:checked:checked ~ .Estamento-3,
#Estamento-4:checked:checked ~ .Estamento-4,
#Estamento-5:checked:checked ~ .Estamento-5,
#Estamento-6:checked:checked ~ .Estamento-6 {
  border-color: #24c6ab;
  background: #24c6ab;
}
#Estamento-1:checked:checked ~ .Estamento-1 .dot,
#Estamento-2:checked:checked ~ .Estamento-2 .dot,
#Estamento-3:checked:checked ~ .Estamento-3 .dot,
#Estamento-4:checked:checked ~ .Estamento-4 .dot,
#Estamento-5:checked:checked ~ .Estamento-5 .dot,
#Estamento-6:checked:checked ~ .Estamento-6 .dot {
  background: #fff;
}
#Estamento-1:checked:checked ~ .Estamento-1 .dot::before,
#Estamento-2:checked:checked ~ .Estamento-2 .dot::before,
#Estamento-3:checked:checked ~ .Estamento-3 .dot::before,
#Estamento-4:checked:checked ~ .Estamento-4 .dot::before,
#Estamento-5:checked:checked ~ .Estamento-5 .dot::before,
#Estamento-6:checked:checked ~ .Estamento-6 .dot::before {
  opacity: 1;
  transform: scale(1);
}

#Estamento-1:checked:checked ~ .Estamento-1 span,
#Estamento-2:checked:checked ~ .Estamento-2 span,
#Estamento-3:checked:checked ~ .Estamento-3 span,
#Estamento-4:checked:checked ~ .Estamento-4 span,
#Estamento-5:checked:checked ~ .Estamento-5 span,
#Estamento-6:checked:checked ~ .Estamento-6 span {
  color: #fff;
}

@media screen and (max-width: 1520px) {
  .wrapper .Estamento {
    height: 40px;
    width: 120px;
    font-size: 14px;
  }
}
@media screen and (max-width: 1000px) {
    .wrapper .Estamento {
    height: 30px;
    width: 90px;
    font-size: 10px;
  }
}

@media screen and (max-width: 770px) {
  .wrapper .Estamento {
    height: 30px;
    width: 80px;
    font-size: 9px;
    margin-right: 10px;
  }
}

</style>
